export default {
  create: {
    success: 'Utilisateur créé avec succès',
    error: "Impossible de créer l'utilisateur"
  },
  update: {
    success: "Modification de l'utilisateur effectué avec succès",
    error: "Impossible de mettre à jour l'utilisateur"
  },
  delete: {
    success: "Suppression de l'utilisateur effectué avec succès",
    error: "Impossible de supprimer l'utilisateur"
  }
}
